module.exports = __webpack_public_path__ + "static/img/8.3179b2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/8.jpg
// module id = ut6k
// module chunks = 16